import { render, staticRenderFns } from "./PastDueWizardAccount.vue?vue&type=template&id=b4872838&scoped=true&"
import script from "./PastDueWizardAccount.vue?vue&type=script&lang=js&"
export * from "./PastDueWizardAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4872838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4872838')) {
      api.createRecord('b4872838', component.options)
    } else {
      api.reload('b4872838', component.options)
    }
    module.hot.accept("./PastDueWizardAccount.vue?vue&type=template&id=b4872838&scoped=true&", function () {
      api.rerender('b4872838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/pastduewizard/PastDueWizardAccount.vue"
export default component.exports